module.exports = __webpack_public_path__ + "img/1545216685.4c0a4bdb.jpg";